<template>
  <Main>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <p class="font-weight-bold primary--text mb-6 form__title">
            CORRETORA
          </p>
        </v-col>
        <v-col cols="12" class="pb-6">
          <v-switch
            class="pa-0 ma-0 justify-self-center d-inline-block new-insurance-form__switch"
            v-model="form.ativo"
            inset
            hide-details
            dense
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
            <BaseFormInput
              id-element="nome"
              placeholder="Inserir"
              v-model="form.nome"
              required
              :rules="[requiredInput]"
              label-text="Nome"
              validate-on-blur
            />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
            <BaseFormInput
              id-element="susep"
              placeholder="Inserir"
              v-model="form.registro_susep"
              required
              :rules="[requiredInput, validSusep]"
              label-text="Registro SUSEP"
              validate-on-blur              
            />
        </v-col>
        <v-col cols="12" sm="5" md="4" class="pr-sm-5">
          <DocumentInput
            id-element="cnpj"
            placeholder="Inserir"
            v-model="form.cnpj"
            required
            :rules="[requiredInput, isValidCnpjDocument]"
            label-text="CNPJ"
            validate-on-blur
            document-type="cnpj"
          />
        </v-col>
        <v-col cols="12" sm="7" md="8">
          <BaseFormInput
            id-element="companyName"
            placeholder="Inserir"
            v-model="form.razao_social"
            required
            :rules="[requiredInput]"
            label-text="Razão Social"
            validate-on-blur
          />
        </v-col>
      </v-row>
    </v-form>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            class="white--text pink"
            v-html="'CANCELAR'"
            width="100%"
            :to="{ name: 'brokers' }"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <BaseButton
            class="white--text secondary"
            v-html="'SALVAR'"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </Main>
</template>
<script>
import {
  requiredInput,
  isValidCnpjDocument,
  validSusep
} from "@/utils/rules.js";
import DocumentInput from "@/components/form/DocumentInput.vue";
import { api } from "@/api";
export default {
  data() {
    return {
      requiredInput,
      isValidCnpjDocument,
      validSusep,
      api,
      form: {
        nome:'',
        cnpj:'',
        razao_social:'',
        registro_susep:'',
        id:'',
        ativo:true,
      }
    };
  },
  components: {
    DocumentInput
  },
  computed: {
    statusSwitch() {
      const status = this.form.ativo ? "Ativo" : "Inativo";
      return `Status ${status}`;
    }
  },
  async created() {
    if (this.$route.params.id) {
      this.form = (await this.fetchData(this.$route.params.id));
    }
  },
  methods: {
    async fetchData(id) {
      return (await this.api.get(`/v1/corretoras/${ id }`)).data;
    },
    async submit() {
      if(this.$refs.form.validate()) {
         var payload = this.getPayload();   

         if(this.form.id != null && this.form.id.length > 0) {
           this.api.put(`/v1/corretoras/${ this.form.id }`, payload);
         }
         else {
           delete payload.id;          
           this.api.post(`/v1/corretoras/`, payload);
         }  

      this.$router.push({ name: "brokers" });
      }
    },
    getPayload() {
      var payload = { ...this.form };
      
      var cnpj = "";
      for(let i = 0; i < payload.cnpj.length; i++) {
        if(payload.cnpj[i] != "." && payload.cnpj[i] != "/" && payload.cnpj[i] != "-") {
          cnpj += payload.cnpj[i];
        }
      }

      payload.cnpj = cnpj;
      return payload;
    }
  }
};
</script>
